export default __webpack_public_path__ + "static/media/gallery33.65a14bad.webp";